module.exports = __webpack_public_path__ + "img/cloud-2.2fbbec17.png";